import React from "react";
import "./PathOptionGroup.css";

function PathOptionGroup({ title, children, note, noteOnHover = false, className = "" }) {
  return (
    <div className={`path-option-group ${className} ${noteOnHover ? 'has-hover-note' : ''}`}>
      {title && (
        <h3 className="path-option-group-title">
          {title}
          {note && noteOnHover && (
            <span className="note-indicator" title={note}>ℹ️</span>
          )}
        </h3>
      )}
      <div className="path-option-group-options">
        {children}
      </div>
      {note && !noteOnHover && (
        <div className="path-option-group-note">
          {note}
        </div>
      )}
      {note && noteOnHover && (
        <div className="path-option-group-note-hover">
          {note}
        </div>
      )}
    </div>
  );
}

export default PathOptionGroup;

